import { FC } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_CAMPAIGN_BY_ID } from "graphql/campaign/campaign.query";
import CreateOrEditCampaignModal from "modals/CreateOrEditCampaignModal/CreateOrEditCampaignModal";
import { MainLayoutContainer } from "components/Layout";

type CampaignCreateOrEditProps = {
  edit?: boolean;
};

export const CampaignCreateOrEdit: FC<CampaignCreateOrEditProps> = ({
  edit = false,
}) => {
  const { campaignId, organizationId } = useParams();
  const navigate = useNavigate();
  const { data: campaignData, loading } = useQuery(GET_CAMPAIGN_BY_ID, {
    variables: { campaignId },
    skip: !edit || !campaignId,
  });

  const campaign = campaignData?.campaign_by_pk || null;
  const cancelPath = organizationId
    ? `/organization/${organizationId}/campaigns`
    : "/campaigns";

  const handleCreateOrEditCampaignChange = () => {
    navigate(cancelPath);
  };

  const handleCreateOrEditCampaignModalDismiss = () => {
    navigate(cancelPath);
  };

  if (edit && loading) {
    return (
      <MainLayoutContainer title="Loading..." loading={true}>
        <div />
      </MainLayoutContainer>
    );
  }

  return (
    <CreateOrEditCampaignModal
      createOrEditCampaignModal={true}
      handleCreateOrEditCampaignModalDismiss={handleCreateOrEditCampaignModalDismiss}
      handleCreateOrEditCampaignChange={handleCreateOrEditCampaignChange}
      campaign={campaign}
    />
  );
};
